// extracted by mini-css-extract-plugin
export default {"customerProfile":"CustomerProfile_customerProfile__rsbXt","customerProfileImage":"CustomerProfile_customerProfileImage__XU2NY"};